import { render } from "./MeetingsPage.vue?vue&type=template&id=54aefc24&scoped=true"
import script from "./MeetingsPage.vue?vue&type=script&lang=js"
export * from "./MeetingsPage.vue?vue&type=script&lang=js"

import "./MeetingsPage.vue?vue&type=style&index=0&id=54aefc24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54aefc24"]])

export default __exports__